import '../sass/Profil.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCode, faCircleArrowDown } from '@fortawesome/free-solid-svg-icons'

function Profil() {
    return <div className="profil" id='profil'>
        <FontAwesomeIcon icon={faCode} size='2xl' style={{color: "#2965FF"}} />
        <h1>MON PROFIL :</h1>
        <p>Etudiant en Master 2 chez Toulouse YNOV Campus, je suis à la recherche d'un CDI à partir du 1er octobre. Grâce à ce site, vous pourrez en apprendre plus sur mes compétences et mon expérience professionelle. Vous pourrez aussi télécharger mon CV.</p>
        <FontAwesomeIcon icon={faCircleArrowDown} size='2xl' style={{color: "#2965FF"}} />
    </div>
}
export default Profil
